import { Button } from "@jmc/solid-design-system/src/components/atoms/Button/Button";
import {
    Colors as ButtonColors,
    Variants as ButtonVariants,
} from "@jmc/solid-design-system/src/components/atoms/Button/Button";
import { CMSButtonProps } from "@jwm/types/CMSButtonProps";

import { colorMap, variantMap } from "./CMSMapperDefinitions";
import { getLink } from "./getLink";

const mapButtonVariants = (cmsVariant: "Outlined" | "Contained"): ButtonVariants => {
    return variantMap.get(cmsVariant) || "contained";
};

const mapButtonColors = (cmsColor: "Primary Color" | "Secondary Color" | "Accent Color"): ButtonColors => {
    return colorMap.get(cmsColor) || "primary";
};

/**
 * transform a CMSButtonProps instance into props for a Button
 */
export const mapButtonProps = (
    cmsButtonProps: CMSButtonProps,
): {
    buttonProps: React.ComponentProps<typeof Button>;
    link: { external: boolean; url: string; url_prefix: string; anchor_id: string };
    text: string;
    fileUrl: string;
    serviceLink?: { servicePage: string; specialty: { title: string } };
} => {
    return {
        buttonProps: {
            variant: mapButtonVariants(cmsButtonProps.variant),
            color: mapButtonColors(cmsButtonProps.color),
            children: null,
        },
        link: getLink(cmsButtonProps.link_group, cmsButtonProps.text),
        text: cmsButtonProps.text,
        fileUrl:
            !cmsButtonProps?.link_group?.external_link &&
            (!cmsButtonProps?.link_group?.internal_page?.[0]?.url ||
                cmsButtonProps?.link_group?.internal_page?.[0]?.url?.length === 0) &&
            cmsButtonProps?.link_group?.file_asset?.url,
        serviceLink: {
            servicePage: cmsButtonProps?.service_link?.service_page,
            specialty: { title: cmsButtonProps?.service_link?.specialty?.[0]?.title },
        },
    };
};
